export default {
  mounted() {
    document.addEventListener('paste', this.onPasteImage)
  },
  destroyed() {
    document.removeEventListener('paste', this.onPasteImage)
  },
  methods: {
    onPasteImage(event) {
      const SKIP_ELEMENTS = ['INPUT', 'TEXTAREA']
      if (SKIP_ELEMENTS.indexOf(event.target.tagName) !== -1) {
        // continue
        // https://ahaslides.atlassian.net/browse/AHA-11567
      } else if (event.clipboardData || event.originalEvent) {
        // Some versions of chrome not for ie11 use event.originalEvent
        const clipboardData = (event.clipboardData || event.originalEvent.clipboardData)
        if (!clipboardData.items) return
        // for chrome
        const { items } = clipboardData
        const len = items.length
        let blob = null
        // items.length is more interesting, preliminary judgment is based on the type of mime, that is, there are several types of mime, the length is several (to be verified)
        // If plain text is pasted, then len=1, if page picture is pasted, len = 2, items [0]. type = text / plain, items [1]. type = image /*'
        // If you paste a picture using the screenshot tool, len = 1, items [0]. type ='image / png'
        // If you paste plain text + HTML, len = 2, items [0], type = text / plain', items [1], type = text / html'

        // Prevent default behavior by not allowing clipboard content to be displayed in div s
        event.preventDefault()

        // Look for the pasted image in items. According to the analysis above, you need to loop
        for (let i = 0; i < len; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            blob = items[i].getAsFile()
          }
        }
        if (blob !== null) {
          this.file = blob

          this.uploadImgFromPaste(blob)
        }
      }
    },
  },
}
